import { render, staticRenderFns } from "./ResellerDetail.vue?vue&type=template&id=146967ae&scoped=true"
import script from "./ResellerDetail.vue?vue&type=script&lang=js"
export * from "./ResellerDetail.vue?vue&type=script&lang=js"
import style0 from "./ResellerDetail.vue?vue&type=style&index=0&id=146967ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146967ae",
  null
  
)

export default component.exports